export const firebaseConfig = {
  apiKey: "AIzaSyDkHfJ5o54TX04ToZHO4nN9z4HNXSPGUfw",
  authDomain: "tour-bd-42afd.firebaseapp.com",
  projectId: "tour-bd-42afd",
  storageBucket: "tour-bd-42afd.appspot.com",
  messagingSenderId: "242755473954",
  appId: "1:242755473954:web:53381b0786bb002ebcf07b",
};
